import { useRecoilState } from "recoil";
import { onboardingProgressState } from "recoil/onboardingProgressAtom";
import { useCallback } from "react";

export function useOnboardingProgress() {
  const [state, setState] = useRecoilState(onboardingProgressState);

  const setProgress = useCallback(
    (newProgress: number) => {
      setState((prevState) => ({
        ...prevState,
        progress: newProgress,
      }));
    },
    [setState]
  );

  const setSectionCount = useCallback(
    (newSectionCount: number) => {
      setState((prevState) => ({
        ...prevState,
        sectionCount: newSectionCount,
      }));
    },
    [setState]
  );

  return {
    progress: state.progress,
    sectionCount: state.sectionCount,
    setProgress,
    setSectionCount,
  };
}